module.exports = __webpack_public_path__ + "images/emoji/water_buffalo.091884e6c218b23e2845.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/water_buffalo.png
// module id = CSJ0
// module chunks = 14